import type { ApplicationStatus } from '~entities/application';

import type { AbstractOption } from '~shared/types/abstract-options';

const options = [
  {
    title: 'Down payment required',
    value: 'WAITING_DOWN_PAYMENT',
    checkmarkStyle: 'checkbox',
  },
  {
    title: 'Success',
    value: 'SUCCESS',
    checkmarkStyle: 'checkbox',
  },
] as const;

export const applicationStatusOptions =
  options as any as AbstractOption<ApplicationStatus>[];
